import React from "react";

function SecondaryButton({ children, onClick, className }) {
  const styleClasses = [
    'font-RobotoBlack',
    'text-evcpa-darkpurple',
    'uppercase',
    'text-sm',
    'leading-none',
    'tracking-wider',
  ];

  return (
    <button className={`${styleClasses.join(' ')} ${className}`} onClick={onClick} type="button">
      {children}
    </button>
  );
}

export default SecondaryButton;